import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import TopNavBarNew from "../../Components/TopNavBarNew";
import BottomNavBarNew from "../../Components/BottomNavBarNew";
import * as ContentfulMarkdown from 'react-markdown';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import styles from "./PillAbortionTestSuccess.module.css";

export default function PillAbortionTestSuccess({ appLanguage }) {
  const [pageState, setPageState] = useState({
    title: "",
    title2: "",
    description: "",
    buttonText: "",
    image: "",
  });

  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Abor Test Result";

    // Direct localStorage reading
    const entries = JSON.parse(localStorage.getItem('ayaAppEntries') || '[]');
    const assets = JSON.parse(localStorage.getItem('ayaAppAssets') || '[]');

    // Add inline helper functions
    const getEntryField = (entryId, field, language = appLanguage || 'es-VE') => {
      const entry = entries.find(e => e.sys.id === entryId);
      if (!entry?.fields?.[field]) return '';
      
      const fieldValue = entry.fields[field];
      if (typeof fieldValue === 'object' && fieldValue[language]) {
        return fieldValue[language];
      }
      return fieldValue;
    };

    const getAssetUrl = (assetId, language = appLanguage || 'es-VE') => {
      const asset = assets.find(a => a.sys.id === assetId);
      if (!asset?.fields?.file) return '';
      
      const localizedFile = asset.fields.file[language];
      if (localizedFile?.url) {
        const url = localizedFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }
      
      const fallbackFile = Object.values(asset.fields.file)[0];
      if (fallbackFile?.url) {
        const url = fallbackFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }
      
      return '';
    };

    const entryId = "2LRjG3OLBpI9Bik3Hjfqx8";
    const imageAssetId = "ArNk0Jwo6QeP68r5rCIFB";

    setPageState({
      title: getEntryField(entryId, 'title') || "",
      title2: getEntryField(entryId, 'title2') || "",
      description: getEntryField(entryId, 'description') || "",
      buttonText: getEntryField(entryId, 'buttonText') || "",
      image: getAssetUrl(imageAssetId) || "",
    });
  }, [appLanguage]);

  return (
    <>
    <div className={styles.pageContainer}>
      <TopNavBarNew backgroundColor="#4450E5" breadcrumbColor="#fff" />
      
     <div className={styles.background}>
     <div className={styles.extraSpace}></div>
        <h1 className={styles.title}>{pageState.title}</h1>
        <h2 className={styles.title2}>{pageState.title2}</h2>
        
        {pageState.image && (
          <div className={styles.imageContainer}>
            <img
              src={pageState.image}
              alt="Success Illustration"
              className={styles.image}
            />
          </div>
        )}

        {/* ✅ Render description using Contentful Markdown */}
        {pageState.description && typeof pageState.description === 'object' ? (
          documentToReactComponents(pageState.description)
        ) : (
          <ContentfulMarkdown
            className={styles.linkText}
            children={pageState.description}
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw]}
            allowDangerousHtml={true} 
          />
        )}

        <button 
          className={styles.button} 
          onClick={() => history.push('/abor-library')}
        >
          {pageState.buttonText}
        </button>
        <BottomNavBarNew appLanguage={appLanguage}/>
      </div>
    </div>
    </>
  );
}